import React, {useState} from "react"
import PropTypes from "prop-types"
import Table from 'react-bootstrap/Table'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FormattedMessage, useIntl } from "react-intl"
import { WingsButton } from "../../global-styles/wingspans-ui/components"
import "./schools-athletics.css"

const SectionAthletics = ({ schoolData = {} }) => {
  const { formatMessage } = useIntl()
  const { athletics = [] } = schoolData || {}
  const [viewingMore, setViewingMore] = useState(false)

  // Check which columns have data across all rows
  const hasIntramuralMen = athletics.some((item) => item?.intramuralMen === true)
  const hasIntramuralWomen = athletics.some((item) => item?.intramuralWomen === true)
  const hasIntercollegiateMen = athletics.some((item) => item?.intercollegiateMen === true)
  const hasIntercollegiateWomen = athletics.some((item) => item?.intercollegiateWomen === true)
  const hasScholarshipMen = athletics.some((item) => item?.scholarshipMen === true)
  const hasScholarshipWomen = athletics.some((item) => item?.scholarshipWomen === true)

  const hasIntramural = hasIntramuralMen || hasIntramuralWomen
  const hasIntercollegiate = hasIntercollegiateMen || hasIntercollegiateWomen
  const hasScholarship = hasScholarshipMen || hasScholarshipWomen

  const men = (content) => (
    <div className="men">
      {content}
    </div>
  )
  const women = (content) => (
    <div className="women">
      {content}
    </div>
  )

  return (
    <>
    <div className="sports">
      <div className="athletics-header-container">
        <h3 className="tabs-section-heading"><FormattedMessage id="athletics-extracurriculars" defaultMessage="Athletics & Extracurriculars"/></h3>
        <div className="athletics-table-legend">
          {men(<FormattedMessage id="mens" defaultMessage="Men's"/>)}
          {women(<FormattedMessage id="womens" defaultMessage="Women's"/>)}
        </div>
      </div>
      <div className="sports-men">
        <div className={`expandable ${ viewingMore ? 'tall' : 'short' }`}>
          <div className="table-responsive">
          <Table responsive className="athletics-table">
            <thead>
              <tr>
                <th><FormattedMessage id="sport" defaultMessage="Sport"/></th>
                {hasIntramural && <th colSpan={2}><FormattedMessage id="intramural" defaultMessage="Intramural"/></th>}
                {hasIntercollegiate && <th colSpan={2}><FormattedMessage id="intercollegiate" defaultMessage="Intercollegiate"/></th>}
                {hasScholarship && <th colSpan={2}><FormattedMessage id="scholarship" defaultMessage="Scholarship"/></th>}
              </tr>
            </thead>
            <tbody>
            {Array.isArray(athletics) && athletics.map((item, idx) => (
              <tr key={idx}>
                <td>{item?.label}</td>
                {hasIntramuralMen && <td>{item?.intramuralMen === true ? men(formatMessage({id: "yes" , defaultMessage: "Yes"})) : '–'}</td>}
                {hasIntramuralWomen && <td>{item?.intramuralWomen === true ? women(formatMessage({id: "yes" , defaultMessage: "Yes"})) : '–'}</td>}
                {hasIntercollegiateMen && <td>{item?.intercollegiateMen === true ? men(formatMessage({id: "yes" , defaultMessage: "Yes"})) : '–'}</td>}
                {hasIntercollegiateWomen && <td>{item?.intercollegiateWomen === true ? women(formatMessage({id: "yes" , defaultMessage: "Yes"})) : '–'}</td>}
                {hasScholarshipMen && <td>{item?.scholarshipMen === true ? men(formatMessage({id: "yes" , defaultMessage: "Yes"})) : '–'}</td>}
                {hasScholarshipWomen && <td>{item?.scholarshipWomen === true ? women(formatMessage({id: "yes" , defaultMessage: "Yes"})) : '–'}</td>}
              </tr>
            ))}
            </tbody>
          </Table>
          </div>
        </div>
        {!viewingMore &&
          <div className="view-more white w-flex w-justify-center">
            <div className="view-more__inner w-flex w-justify-center">
              <WingsButton variant="tertiary" size="medium" onClick={() => setViewingMore(true)}>
                <span><FormattedMessage id="view-more" defaultMessage="View More"/></span>
                <span className="icon--chevron-toggle">
                  <span className="chevron-down"></span>
                </span>
              </WingsButton>
            </div>
          </div>
        }
        {viewingMore &&
          <div className="w-flex w-justify-center">
            <WingsButton variant="tertiary" size="medium" onClick={() => setViewingMore(false)}>
              <FormattedMessage id="view-less" defaultMessage="View Less"/>
            </WingsButton>
          </div>
        }
      </div>
    </div>
    </>
  )
}

SectionAthletics.propTypes = {
  schoolData: PropTypes.shape({
    athletics: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        intramuralMen: PropTypes.bool,
        intramuralWomen: PropTypes.bool,
        intercollegiateMen: PropTypes.bool,
        intercollegiateWomen: PropTypes.bool,
        scholarshipMen: PropTypes.bool,
        scholarshipWomen: PropTypes.bool,
      })
    ),
  }),
}

SectionAthletics.defaultProps = {
  schoolData: {
    athletics: [],
  },
}

export default SectionAthletics
